<template>
    <footer id="footer-login">
        <div id="logo-footer-login">
            <img src="../assets/img/logo_white.png" alt="logo">
        </div>
        <div class="clearfix"></div>
        <span>{{year}} Eurocaja Rural. Todos los derechos reservados.</span>

        <div id="social">
            <span>Síguenos</span>
            <a href="https://www.facebook.com/eurocajarural" target="_blank" class="icon">%</a>
            <a href="https://www.youtube.com/eurocajarural" target="_blank" class="icon">=</a>     
            <a href="https://twitter.com/eurocajarural" target="_blank" class="icon">3</a>    
            <a href="https://www.linkedin.com/company/eurocajarural/" target="_blank" class="icon">&</a> 
        </div>
        
    </footer>    
</template>


<script>
export default {
    name: 'FooterLoginComponent',
    data() {
        return {
            year:null,
        }
    },
    mounted() {
        var actualYear = new Date();
        this.year =  actualYear.getFullYear();      
        return this.year;
    }
}
</script>